<template>
  <div class="w-80">
    <h3 class="mb-6 font-montserrat">Delete account</h3>

    <FormulateForm v-model="form" @submit="onSubmit">
      <div class="flex flex-col gap-4">
        <p>Are you sure you want to delete {{ account.name }}?</p>

        <FormulateInput
          type="submit"
          :wrapper-class="['mt-4']"
          :input-class="['mb-0 group']"
          :element-class="['w-max mx-auto']"
          :disabled="isLoading"
        >
          <span :class="['font-nunito', { hidden: isLoading }]">Confirm</span>
          <lottie
            :options="LOADING_ANIMATION_OPTIONS"
            :style="{ width: '1.5rem' }"
            :class="{ 'hidden': !isLoading, 'group-hover:hidden': isLoading }"
          />
          <lottie
            :options="LOADING_ANIMATION_OPTIONS_DARK"
            :style="{ width: '1.5rem' }"
            :class="{
              'hidden': !isLoading,
              'hidden group-hover:block': isLoading,
            }"
          />
        </FormulateInput>
      </div>
    </FormulateForm>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from '../../../../js/store/index.js'
import { EventBus } from '../../../../js/plugins/event-bus'
import {
  LOADING_ANIMATION_OPTIONS,
  LOADING_ANIMATION_OPTIONS_DARK,
} from '../../../../js/util/constants.js'

export default defineComponent({
  name: 'ModalDeleteAccount',

  props: {
    config: { default: null },
  },

  setup(props) {
    const store = useStore()

    const isLoading = ref(false)
    const accountId = computed(() => props.config?.id || null)
    const account = computed(() => {
      if (accountId.value) {
        return store.getters['contributors/getAccount'](accountId.value)
      }

      return null
    })

    const form = ref({})

    const payload = computed(() => {
      return {
        id: accountId.value,
      }
    })

    const onSubmit = async () => {
      isLoading.value = true
      const success = await store.dispatch(
        'contributors/dispatchDeleteAccount',
        payload.value,
      )
      isLoading.value = false

      if (success) {
        EventBus.$emit('showModal', false)
        EventBus.$emit('triggerAlertResponse', {
          status: 'success',
          message: 'Account deleted',
        })
        EventBus.$emit('dispatchUpdateAccounts')
      }
    }

    return {
      LOADING_ANIMATION_OPTIONS,
      LOADING_ANIMATION_OPTIONS_DARK,
      isLoading,
      form,
      account,
      onSubmit,
    }
  },
})
</script>
